import { MDBCard, MDBCol, MDBRow } from 'mdbreact'

import Checkbox from './checkbox'
import React from 'react'
import styled from 'styled-components'

const MDBCardFBox = styled(MDBCard)`
  display: inline-block;
  text-shadow: 1.5px 1px #d4d5d6;
  width: 100%;
`

const MDBCardListBoxes = styled(MDBCard)`
  text-align: left;
  margin: 0px auto;
  padding: 0px 5px;
  display: inline;
  float:left;
  width:100%;
}`

const CheckboxContainer = (props) => {
  // array of N elements, where N is the number of rows needed
  const rows = [...Array(Math.ceil(props.featuredServices.length / 4))]
  // chunk the featuredServices into the array of rows
  const featuredServices = rows.map((row, idx) =>
    props.featuredServices.slice(idx * 4, idx * 4 + 4)
  )
  // map the rows as div.row
  const content = featuredServices.map((row, idx) => (
    <MDBCol
      key={idx}
      id={idx}
      xs="12"
      md="6"
      lg="3"
      className="col-12 px-3 m-0"
    >
      {row.map((item, key) => (
        <MDBCardListBoxes key={key} className="m-2">
          <Checkbox
            id={item.node.id}
            name={item.node.id}
            checked={props.checkedItems[item.node.id]}
            onChange={props.handleCheckboxesChange}
          />
          <label style={{ display: 'inline' }} for={item.node.id}>
            {item.node.name}
          </label>
        </MDBCardListBoxes>
      ))}
    </MDBCol>
  ))

  return (
    <MDBCardFBox>
      <MDBRow className="my-2 mx-auto">{content}</MDBRow>
    </MDBCardFBox>
  )
}

export default CheckboxContainer
